var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconZoomOutComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-zoom-out ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40836 3.59163C5.31453 3.59163 3.61715 5.28902 3.61715 7.38284C3.61715 9.47667 5.31453 11.1741 7.40836 11.1741C9.50219 11.1741 11.1996 9.47667 11.1996 7.38284C11.1996 5.28902 9.50219 3.59163 7.40836 3.59163ZM2.28381 7.38284C2.28381 4.55264 4.57815 2.2583 7.40836 2.2583C10.2386 2.2583 12.5329 4.55264 12.5329 7.38284C12.5329 8.5707 12.1287 9.66417 11.4504 10.5332L13.4805 12.5632C13.6106 12.6934 13.6106 12.9045 13.4805 13.0346L13.009 13.506C12.8789 13.6362 12.6678 13.6362 12.5376 13.506L10.501 11.4694C9.64144 12.1208 8.57004 12.5074 7.40836 12.5074C4.57815 12.5074 2.28381 10.2131 2.28381 7.38284ZM9.87499 7.07022C9.87499 6.88613 9.72575 6.73689 9.54166 6.73689H5.21488C5.03078 6.73689 4.88154 6.88613 4.88154 7.07022V7.73689C4.88154 7.92098 5.03078 8.07022 5.21488 8.07022H9.54166C9.72575 8.07022 9.87499 7.92098 9.87499 7.73689V7.07022Z",
    fillOpacity: "1"
  }));
}
var IconZoomOut = /*#__PURE__*/React.forwardRef(IconZoomOutComponent);
export default IconZoomOut;